import React, { useCallback } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { MenuOverlay, Paragraph, useMenuOverlay } from '@fs/zion-ui'
import { cssDropDownMenu } from '../../LcrDemo/common/styles'
import TempleSubMenuItems from './TempleSubMenuItems'
import MenuItemWithGlow from './MenuItemWithGlow'
import useMenuEventHandlers from './useMenuEventHandlers'

// #region Styles
const cssMenuItem = css`
  margin: 9px 8px;
  padding: 9px 8px;
  cursor: default;
`
// #endregion

/**
 * @describe - Render a single Nav Menu Item for the LCR Menu.
 */
export default function LcrNavBarItem({ isLcrDashboard, menuText, templeSubMenuItems = [], showGlowMenu }) {
  const [t] = useTranslation()
  const overlay = useMenuOverlay()
  const { isOpen, handleClick } = overlay ?? {}

  const handleGlowMenuClick = useCallback(
    (event) => {
      handleClick(event)
    },
    [handleClick]
  )

  const { handleMenuEvent: handleTempleMenuClick } = useMenuEventHandlers(handleGlowMenuClick)

  const templeMenuAriaLabel = t('lcr.navbar.item.temple.aria-label', 'Temple Menu')

  if (overlay && isLcrDashboard) {
    return (
      <MenuOverlay
        onClose={overlay.close}
        menuButton={
          <MenuItemWithGlow
            menuText={menuText}
            isOpen={isOpen}
            showGlow={showGlowMenu && !isOpen}
            isClickable
            dataTestId={showGlowMenu ? 'lcr-menu-item.temple' : undefined}
            onClick={handleTempleMenuClick}
            aria-label={templeMenuAriaLabel}
          />
        }
        aria-label={templeMenuAriaLabel}
      >
        {showGlowMenu && (
          <div css={cssDropDownMenu}>
            <TempleSubMenuItems templeSubMenuItems={templeSubMenuItems} handleMenuItemClick={handleTempleMenuClick} />
          </div>
        )}
      </MenuOverlay>
    )
  }

  return (
    <div css={cssMenuItem}>
      <Paragraph size="xs">{`${menuText} ${isOpen ? '▴' : '▾'}`}</Paragraph>
    </div>
  )
}
